module.exports = __webpack_public_path__ + "static/media/case_details_01.c0a1b5c7.jpg";